import { ISiteDetails } from "../../api/ISiteDetails";
import EpaCard from "../../leap-components/EpaCard";
import EpaField from "../../leap-components/EpaField";

interface ILicenceProfileSiteDetailsProps {
  siteDetails: ISiteDetails;
}

const LicenceProfileSiteDetails = ({
  siteDetails,
}: ILicenceProfileSiteDetailsProps) => {
  var bodyElements = (
    <div>
      <EpaField label={"Address 1"} value={siteDetails.address1} />
      <EpaField label={"Address 2"} value={siteDetails.address2} />
      <EpaField label={"Address 3"} value={siteDetails.address3} />
      <EpaField label={"Town/City"} value={siteDetails.city} />
      <EpaField label={"County"} value={siteDetails.county} />
      <EpaField label={"Eircode"} value={siteDetails.eircode} />
      <EpaField label={"NACE Code"} value={siteDetails.nacecode} />
      <EpaField label={"NUTS Code"} value={siteDetails.nutscode} />
    </div>
  ) as JSX.Element;

  return <EpaCard title={"Site Details"} content={bodyElements} />;
};

export default LicenceProfileSiteDetails;
